import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Select, Row as DefaultRow, Card as DefaultCard } from 'antd';
import { themeColors } from '../../../constants/themes';
import DefaultInput from '../../../components/common/Input';

export const Input = styled(DefaultInput)`
  font-size: ${({ theme }) => theme.fontSize.small};
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 2em;
  & > *:not(:last-child) {
    margin-right: 1em;
  }
`;

export const Section = styled.div`
  margin-bottom: 1em;
`;

export const CustomRow = styled(DefaultRow)`
  word-wrap: normal;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  & .delete {
    &:hover {
      & > span {
        opacity: 1;
      }
    }
  }
`;

export const LogoContainer = styled('span')`
  width: ${({ marketPlaceName }) =>
    marketPlaceName === 'paypal' || marketPlaceName === 'payoneer' ? '17px' : '32px'};
  height: ${({ marketPlaceName }) => (marketPlaceName === 'creditcard' ? '27px' : '32px')};
  background: ${({ marketPlaceName }) =>
      marketPlaceName === 'payoneer' || marketPlaceName === 'creditcard'
        ? `url(/assets/icons/${marketPlaceName}.svg)`
        : `url(/assets/icons/${marketPlaceName}.png)`}
    center/contain no-repeat;
  vertical-align: middle;
  display: inline-block;
`;

export const ConnectionCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${themeColors.blue};
  border: 1px dashed ${themeColors.blue};
  width: 25%;
  max-width: 50em;
  height: 10em;
  cursor: pointer;
  border-radius: 4px;
  padding: 1em;
  text-align: center;
  & > span:last-child {
    margin-top: 0.5em;
  }
`;

export const SelectWrapper = styled.div`
  margin-bottom: 2em;
  color: ${props => (props.disabled ? 'grey' : 'unset')};
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectLabel = styled.span`
  & > span:first-of-type {
    font-size: 18px;
  }
`;

export const CustomSelect = styled(Select)`
  width: 15em;
  top: 5px;
`;

// Connect Source Styles

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
`;

export const Index = styled.span`
  font-size: ${({ theme }) => theme.fontSize.large};
`;

export const CardHeader = styled.h2`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.small};
`;

export const Card = styled(DefaultCard)`
  width: 220px;
  display: inline-block;
  padding: 10px;
  min-height: 90px;
  margin-right: 15px;
  box-shadow: 0 1px 7px 0 rgba(0, 105, 250, 0.15);
  border-color: ${({ theme, selected }) =>
    selected ? theme.colors.blueMed : theme.colors.greyMid};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.small};

  .ant-card-body {
    padding: 0;
  }

  :hover,
  :focus {
    border-color: ${({ theme }) => theme.colors.blueMed};
  }

  &[disabled] {
    background-color: ${({ theme }) => theme.colors.borderLight};
    color: ${({ theme }) => theme.colors.disabledText};
    border-color: ${({ theme }) => theme.colors.disabledBorder};
    cursor: not-allowed;

    h2${CardHeader} {
      color: ${({ theme }) => theme.colors.disabledText};
    }
  }
`;

export const CardWrapper = styled.div`
  margin: 18px;
  margin-top: 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 50%;
  margin-bottom: 18px;
`;

export const FormGroup = styled.div``;

export const subLabel = css`
  padding-left: 19px;
`;

export const subRow = css`
  margin-bottom: 7px;
`;

export const ButtonGroup = styled.div`
  width: 50%;
  text-align: center;
  margin-top: 20px;
`;
